import t from"@emotion/styled";import{setRadius as o,setFontSize as i,setStepperVariants as l,setFontWeight as a,setColor as r}from"../../utils/generateStyles.js";const n=t.div`
  label: vertical-step;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  column-gap: 12px;
  padding-top: 12px;
  ${e=>e.isDisabled&&{opacity:"0.6"}}
`,c=t.div`
  label: vertical-step-right-container;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`,s=t.div`
  label: vertical-step-number;
  width: 24px;
  height: 24px;
  margin-top: 8px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid;
  font-weight: 500;
  ${()=>o("full")}
  ${()=>i("xs")}
  ${e=>e.onClick&&{cursor:"pointer"}};
  ${e=>e.variant&&{color:l(e.variant).color,borderColor:l(e.variant).borderColor,backgroundColor:l(e.variant).backgroundColor}}
`,p=t.div`
  label: vertical-step-connector;
  position: absolute;
  top: 32px;
  height: calc(100% - 12px);
  width: 1px;
  ${e=>e.variant&&{backgroundColor:l(e.variant).connectorColor}};
  ${e=>e.isLastChild&&{height:"calc(100% - 32px)"}};
  ${e=>e.isLastChild&&!e.isExpanded&&{display:"none"}};
`,d=t.div`
  label: vertical-step-left-container;
  width: 100%;
`,x=t.div`
  label: vertical-step-head-container;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  margin-bottom: 12px;
`,v=t.div`
  label: vertical-step-title-container;
  display: flex;
  flex-direction: column;
`,b=t.div`
  label: vertical-step-title;
  ${()=>i("sm")}
  ${()=>a("medium")}
  ${()=>r("gray-120","color")}
  ${e=>e.clickable&&{cursor:"pointer"}}
`,g=t.div`
  label: vertical-step-sub-title;
  ${()=>i("xs")}
  ${()=>a("regular")}
  ${()=>r("gray-90","color")}
`,S=t.div`
  label: vertical-step-detail-container;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 2px;
  ${()=>r("blue-a40","color")}
`,y=t.div`
  label: vertical-step-detail-text;
  ${()=>i("xs")}
  ${()=>a("regular")}
  margin-right: 8px;
  cursor: pointer;
`,u=t.div`
  label: vertical-step-content;
  padding-bottom: 12px;
`;export{p as VerticalStepConnectorStyled,u as VerticalStepContentStyled,S as VerticalStepDetailContainerStyled,y as VerticalStepDetailTextStyled,x as VerticalStepHeadContainerStyled,d as VerticalStepLeftContainerStyled,s as VerticalStepNumberStyled,c as VerticalStepRightContainerStyled,n as VerticalStepStyled,g as VerticalStepSubtitleStyled,v as VerticalStepTitleContainerStyled,b as VerticalStepTitleStyled};
